import { HttpService } from "@/shared/http.service";
import { useSettingsStoreStore } from "@/store/settings";
import { useRouter } from "vue-router";

export class MenuService {
  $http = new HttpService();
  $router = useRouter();
  $settingsStore = useSettingsStoreStore();
  flowAppUrl = "";

  constructor() {
    this.flowAppUrl = this.$settingsStore.$state.settings.flow_url_app;
  }

  async findMenu() {
    const response = await this.$http.get("api/menus?populate=*&pagination[limit]=100&filters[ativo][$eq]=true");
    return this.builderMenu(response.data);
  }

  openLogin() {
    const url = this.flowAppUrl;
    window.open(`${url}/#/login`, "_blank");

  }

  openRegister() {
    const url = this.flowAppUrl;
    window.open(`${url}/#/login?form=register`, "_blank");
  }

  builderMenu(menu) {
    const pai = menu.filter((item) => {
      return !item.menuPaiNome && item.titulo;
    });
    pai.forEach((item) => {
      item["menu"] = this.pegaItens(menu, item.nome);
    });
    pai.sort((a, b) => a.ordem - b.ordem);
    return pai;
  }

  pegaItens(menu, paiNome) {
    const pai = menu.filter((item) => {
      return item.menuPaiNome === paiNome && item.titulo;
    });
    pai.forEach((item) => {
      item["menu"] = this.pegaItens(menu, item.nome);
    });
    pai.sort((a, b) => a.titulo.localeCompare(b.titulo));
    return pai;
  }
}